import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alert alert-dismissible bg-light-info d-flex flex-column flex-sm-row w-100 p-5 mb-10" }
const _hoisted_2 = { class: "svg-icon svg-icon-3hx svg-icon-info me-4 mb-5 mb-sm-0" }
const _hoisted_3 = { class: "d-flex flex-column pe-0 pe-sm-10" }
const _hoisted_4 = { class: "fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_component_inline_svg, { src: $props.svg }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", _hoisted_4, _toDisplayString($props.title), 1),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}